import React, { useLayoutEffect, useState } from 'react'
import EmbedBlock from './EmbedBlock'
import styled from 'styled-components'
import { breakpoints, mixins, sizes, fonts, colors } from '../css-variables'
import Block from './WordPressBlock'
import GravityForm from '../content-blocks/GravityForm'
import Columns from '../parts/WordPressColumns'
import ImageSection from '../content-blocks/ImageSection'
import AccordionNavigation from './AccordionNavigation'
import SpecialBlock from '../content-modules/SpecialBlock'
import FooGallery from '../content-blocks/FooGallery'
import AdvocacyEmbed from '../content-blocks/AdvocacyEmbed'
import FormErrorBoundary from '../FormErrorBoundary'
import EmailTermsForm from './EmailTermsForm'
import { ImageBlock } from '../../blocks/ImageBlock'
import { CoreList } from '../../blocks/CoreList'
import { getEmbedTypeFromBlockContent } from '../../utils/embed-block'

const WordPressContentBlocks = ({
  className,
  blocks,
  content,
  eventCategory,
  stagger,
}) => {
  const [path, setPath] = useState('')
  useLayoutEffect(() => {
    const path = typeof window !== 'undefined' ? window.location.pathname : null
    if (path.includes('/email/email-terms-and-conditions')) {
      setPath(path)
    }
  }, [])

  const RenderedBlocks = blocks
    ? blocks.map((block) => {
        switch (block.name) {
          case 'core/separator':
            return (
              <div
                key={block.order}
                dangerouslySetInnerHTML={{
                  __html: block.originalContent,
                }}
              />
            )
          case 'core/image':
            return new ImageBlock(block).render({ key: block.order })
          case 'core/group':
          case 'acf/events-listing-section':
            return null
          case 'acf/note-listing':
            return null
          case 'acf/image-section':
            const imagesection =
              block.isDynamic && block.dynamicContent !== ''
                ? block.dynamicContent
                : block.originalContent
            return (
              <ImageSection key={block.order} data={imagesection} defaultPage />
            )
          case 'acf/special-block':
            return <SpecialBlock key={block.order} block={block} />

          case 'acf/accordion-navigation':
            return (
              <AccordionNavigation
                key={block.order}
                className={block.name.replace('/', '-')}
                block={block}
              />
            )
          case 'acf/advocacy-embed':
            return <AdvocacyEmbed block={block} />
          case 'acf/staff-search':
            return (
              <Block
                key={block.order}
                className={block.name.replace('/', '-')}
                block={block}
                product
              />
            )
          case 'core/columns':
            return (
              <Columns
                className={block.name.replace('/', '-')}
                block={block}
                key={block.order}
              />
            )
          case 'core/list':
            return (
              <Block
                className={block.name.replace('/', '-')}
                block={new CoreList(block)}
                key={block.order}
              />
            )

          case 'core/buttons':
            if (block?.innerBlocks?.[0]?.originalContent) {
              let innerRenderedBlocks = []
              block.innerBlocks.forEach((innerBlock) => {
                innerRenderedBlocks.push(
                  <Block
                    className={innerBlock.name.replace('/', '-')}
                    block={innerBlock}
                    key={innerBlock.order}
                  />
                )
              })
              return (
                <div key={block.order} className={block.name.replace('/', '-')}>
                  {innerRenderedBlocks}
                </div>
              )
            }
            break
          case 'gravityforms/form':
            const shortcode =
              block.isDynamic && block.dynamicContent !== ''
                ? block.dynamicContent
                : block.originalContent
            let idStart = shortcode.indexOf('gform_wrapper_')
            idStart += 14
            let idEnd = shortcode.indexOf("\'", idStart)
            const formId = shortcode.substring(idStart, idEnd)

            if (path && path.includes('/email/email-terms-and-conditions')) {
              return (
                <FormErrorBoundary
                  key={`${block.name}{${block.originalContent}`}
                >
                  <EmailTermsForm formId={formId} />
                </FormErrorBoundary>
              )
            } else if (idStart > -1) {
              return (
                <FormErrorBoundary
                  key={`${block.name}{${block.originalContent}`}
                >
                  <GravityForm
                    key={block.order}
                    className={block.name.replace('/', '-')}
                    id={formId}
                  />
                </FormErrorBoundary>
              )
            }

            break

          //Add case to handle news/stories that use the freeform block but do not have blocks... and then use content instead of original content because it has the html tags
          //Also added css below that is duplicated from WPBlock
          case 'core/freeform':
            return (
              <Block
                className={block.name.replace('/', '-')}
                block={block}
                key={block.order}
              />
            )
          case 'core-embed/vimeo':
            return (
              <div className="wp-block-embed" key={block.order}>
                <EmbedBlock source={block.originalContent} type="vimeo" />
              </div>
            )
          case 'core-embed/youtube':
            return (
              <div className="wp-block-embed" key={block.order}>
                <EmbedBlock source={block.originalContent} type="youtube" />
              </div>
            )
          case 'core-embed/instagram':
            return (
              <div className="wp-block-embed" key={block.order}>
                <EmbedBlock source={block.originalContent} type="instagram" />
              </div>
            )
            case 'core/embed':
                const embedType = getEmbedTypeFromBlockContent(block?.originalContent)
                const embedWrapperClass =
                  (block?.originalContent &&
                    block?.originalContent.includes('flickr')) ||
                  block?.originalContent.includes('tryinteract') ||
                  (block?.originalContent &&
                    block?.originalContent.includes('instagram'))
                    ? 'embed-wrapper'
                    : null
                return (
                  <div
                    className={`wp-block-embed ${embedWrapperClass}`}
                    key={block.order}
                  >
                    <EmbedBlock
                      source={block.originalContent}
                      type={embedType}
                    />
                  </div>
                )
          case 'fooplugins/foogallery':
            // we have to pass in the whole content to get good image sources
            return (
              <FooGallery
                className={block.name.replace('/', '-')}
                content={content}
                key={block.order}
              />
            )
          default:
            if (block.originalContent.length > 0) {
              return (
                <Block
                  key={block.order}
                  className={block.name.replace('/', '-')}
                  block={block}
                />
              )
            } else {
              return null
            }
        }
      })
    : null

  return (
    <div className={className} id="Top">
      {RenderedBlocks && <div className="content">{RenderedBlocks}</div>}
      {!RenderedBlocks && (
        <div
          className="content core-freeform"
          dangerouslySetInnerHTML={{ __html: content }}
        ></div>
      )}
    </div>
  )
}

const StyledWordPressContentBlocks = styled(WordPressContentBlocks)`
  /* Start Styles copied form WPBlock - should these be here?*/
  min-width: 300px;
  width: 100%;
  max-width: 303px;
  margin-left: auto;
  margin-right: auto;

  @media screen and ${breakpoints.tabletS} {
    max-width: 536px;
    padding-left: 0;
    padding-right: 0;
    margin-left: auto;
    margin-right: auto;
  }
  @media screen and ${breakpoints.laptopS} {
    max-width: 712px;
  }
  .core-freeform {
    margin-bottom: ${sizes.s32};
  }
  /* End Styles copied form WPBlock*/

  margin: 0 auto;
  position: relative;
  display: block;

  @media screen and ${breakpoints.laptopS} {
    max-width: 712px;
  }

  hr.wp-block-separator {
    ${mixins.separator}
  }

  h2 {
    padding-bottom: 0; // REMOVE H2 UNDERLINE FROM DEFAULT PAGES
    &:after {
      display: none; // REMOVE H2 UNDERLINE FROM DEFAULT PAGES
    }
  }
  .core-freeform {
    margin-bottom: ${sizes.s32};
    text-align: left;
    h2,
    h3 {
      font-family: ${fonts.eaves};
      font-weight: bold;
      font-style: italic;
      color: ${colors.titleColor};
    }
    h2 {
      font-size: ${sizes.s32};
      line-height: ${sizes.s36};
      margin-bottom: ${sizes.s32};
      margin-top: ${sizes.s48}; // ex: email login page
      padding-bottom: 0;
      &:after {
        display: none; // REMOVE H2 UNDERLINE FROM DEFAULT PAGES
      }

      @media screen and ${breakpoints.tabletS} {
        font-size: ${sizes.s36};
        line-height: ${sizes.s42};
        margin-top: ${sizes.s58}; // ex: email login page
      }
    }
    h3 {
      font-size: ${sizes.s26};
      margin-bottom: ${sizes.s24};
      line-height: ${sizes.s32};
    }
    a {
      ${mixins.a}
    }
  }
  .core-buttons {
    .core-button {
      &:first-child {
        @media screen and ${breakpoints.tabletS} {
          margin-left: 0;
        }
      }
    }
  }

  .wp-block-embed {
    margin-bottom: 26px;
  }
  .advocacy-embed {
    iframe:nth-of-type(2) {
      display: none;
    }
  }
`

export default StyledWordPressContentBlocks
